import { Box, Container } from '@material-ui/core'
import { useEffect, useMemo, useState } from 'react'
import { Helmet } from 'react-helmet'
import { useDispatch } from 'react-redux'
import { useLocation } from 'react-router'
import AddEditChapter from 'src/components/chapter/AddEditChapter'
import AddUpdateDialog from 'src/components/common/addUpdateDialog'
import CommonStepper from 'src/components/common/commonStepper'
import CreateMoreBtn from 'src/components/common/createMoreBtn'
import FilterSection from 'src/components/common/filterSection'
import useQueryTable from 'src/hooks/useQueryTable'
import { DeleteUnitById, GetUnits } from 'src/redux/actions'
import { LocalTable } from 'src/ui/Table'
import { GetUnitTableColumns } from 'src/util/columns'

import AddEditCourse from '../components/course/AddEditCourse'

const steps = [
  'Create Course',
  'Create Chapter',
];

const UnitList = () => {
  const dispatch = useDispatch()
  const location = useLocation()
  const [recordToEdit, setRecordToEdit] = useState()
  const [customFilterQuery, setCustomFilterQuery] = useState()
  const [searchText, setSearchText] = useState(null)
  const [activeStep, setActiveStep] = useState(0);
  const [firstStepData, setFirstStepData] = useState(null);

  const [{ pageIndex, pageSize }, setPagination] = useState({
    pageIndex: 0,
    pageSize: 10,
  })

  const { data, isLoading, isFetching, refetch } = useQueryTable({
    name: 'units',
    searchText: searchText,
    pageIndex: pageIndex,
    pageSize: pageSize,
    additionalFilters: customFilterQuery,
  })

  // filter course list by courseId
  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const lessonId = params.get("_id") || "";

    setCustomFilterQuery(prev => ({
      ...prev,
      _id: lessonId,
    }));
  }, [location.search]);

  // delete table list function
  const onDeleteRow = async recordToDelete => {
    if (recordToDelete) {
      await dispatch(DeleteUnitById(recordToDelete))
      refetch()
    }
  }

  // set course data for add chapter by action button
  useEffect(() => {
    if (recordToEdit) {
      setFirstStepData({
        languageId: recordToEdit?.course?._id,
        courseId: recordToEdit?._id,
        difficultyLevel: recordToEdit?.difficultyLevel,
      });
    }
  }, [recordToEdit]);

  const columns = useMemo(() => GetUnitTableColumns(), []);

  const actionTitle = Object.keys(recordToEdit || {}).length === 0 ? "create-course" : "";

  return (
    <>
      <Helmet>
        <title>Course | Langistan</title>
      </Helmet>
      <Box
        sx={{
          backgroundColor: 'background.default',
          minHeight: '100%',
          py: 3,
        }}
      >
        <Container maxWidth={false}>

          {/* addButton filters & search section  */}
          <FilterSection
            type="Course"
            path="courses"
            refetch={refetch}
            dispatcher={GetUnits}
            setSearchText={setSearchText}
            setRecordToEdit={setRecordToEdit}
            setCustomFilterQuery={setCustomFilterQuery}
          />

          {/* Course Table Data List */}
          <Box sx={{ pt: 3 }}>
            <LocalTable
              columns={columns}
              onEditClick={setRecordToEdit}
              onDeleteClick={onDeleteRow}
              additionalFilters={customFilterQuery}
              data={data}
              name="Course"
              isLoading={isLoading}
              isFetching={isFetching}
              setPagination={setPagination}
              addChildActionBtnTitle="Create Chapter"
              addChildActionBtnClick={() => {
                setActiveStep(1);
              }}
              viewChildActionBtnTitle="View Chapter"
              viewChildActionBtnUri={`/app/chapters?courseId=`}
            />
          </Box>

          {/* Add & Update course & chapter modal */}
          <AddUpdateDialog
            open={!!recordToEdit}
            title={
              activeStep === 0
                ? `${actionTitle ? "Create" : "Update"} Course`
                : "Create Chapter"
            }
            onClose={() => {
              setRecordToEdit();
              setFirstStepData(null);
              setActiveStep(0);
            }}
            maxWidth="md"
          >
            {/*Stepper Box */}
            {actionTitle && <CommonStepper steps={steps} activeStep={activeStep} />}

            <Box mt={2}>
              {/* Add & Update course form */}
              {activeStep === 0 && (
                <AddEditCourse
                  selectedRow={recordToEdit}
                  refetch={refetch}
                  toggleDrawer={() => {
                    setRecordToEdit();
                    setFirstStepData(null);
                    setActiveStep(0);
                  }}
                  setFirstStepData={setFirstStepData}
                  setActiveStep={setActiveStep}
                  actionTitle={actionTitle}
                />
              )}

              {/* Add & Update chapter form */}
              {activeStep === 1 && (
                <AddEditChapter
                  toggleDrawer={() => {
                    setRecordToEdit();
                    setFirstStepData(null);
                    setActiveStep(0)
                  }}
                  refetch={refetch}
                  firstStepData={firstStepData}
                  setActiveStep={setActiveStep}
                  actionTitle={actionTitle}
                />
              )}

              {/* Add practice success message & add new practice button */}
              {activeStep === 2 && (
                <CreateMoreBtn
                  notification="Chapter created successfully!"
                  createMoreBtnTitle="+ Create more chapter"
                  onCreate={() => {
                    setActiveStep(1)
                  }}
                  onClose={() => {
                    setRecordToEdit()
                    setFirstStepData(null);
                    setActiveStep(0);
                  }}
                />
              )}
            </Box>
          </AddUpdateDialog>
        </Container>
      </Box>
    </>
  )
}

export default UnitList
